import { createContext, useContext, useEffect, useState } from "react";
import { http } from "../lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon
  useEffect(() => {
    const t = localStorage.getItem("alekas_token");
    if (!t) return setUser(false);
    http.get("/auth/me").then(({ data }) => setUser(data)).catch(() => {
      localStorage.removeItem("alekas_token");
      setUser(false);
    });
  }, []);
  const login = async (email, password) => {
    const { data } = await http.post("/auth/login", { email, password });
    localStorage.setItem("alekas_token", data.token);
    setUser(data.user);
    return data.user;
  };
  const register = async (payload) => {
    const { data } = await http.post("/auth/register", payload);
    localStorage.setItem("alekas_token", data.token);
    setUser(data.user);
    return data.user;
  };
  const logout = () => {
    localStorage.removeItem("alekas_token");
    setUser(false);
  };
  return <AuthCtx.Provider value={{ user, login, register, logout, setUser }}>{children}</AuthCtx.Provider>;
}
